<main class="container-fluid ">
  <article class="row bg-white shadow mb-3 mt-3 ml-0 mr-0 ">
    <section class="col-12 p-4 mt-3 mb-1">
      <div class="d-flex justify-content-between align-items-center">
        <header class="row form-group d-flex align-items-center">
          <figure class="m-auto">
            <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block p-2 rounded-circle" alt=""
              height="60">
          </figure>
          <div class="col row">
            <label class="text-dark h5 mb-0 font-weight-bold">Configuración Cámara de Comercio</label>
          </div>
        </header>
        <ng-container *ngIf="authService.getRolUser(adminSuper)">
          <form [formGroup]="formCamara">
            <div class="form-group">
              <label class="small text-secondary mb-0">Cámara de Comercio</label>
              <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara"
                (ngModelChange)="consultaLogoFirma()">
                <option class="" value="null" selected="true">
                  Seleccione
                </option>
                <option class="" *ngFor="let option of camarasLista; let i = index" value="{{option?.codigo_camara}}"
                  [selected]="false">
                  {{option?.desc_camara}}
                </option>
              </select>
            </div>
          </form>
        </ng-container>
      </div>
    </section>
    <section class="col-6 pl-5 mb-5">
      <label class="text-dark h5 font-weight-bold mb-2">Logo</label>
      <p><strong>URL: </strong>{{dataLogo.ruta}}</p>
      <p><strong>Nombre archivo: </strong>{{dataLogo.nombre_archivo}}</p>
      <div class="p-4 d-flex align-content-center flex-column">
        <ng-container *ngIf="logoUrl; else sin_logo">
          <img [src]="logoUrl" class="m-auto img-fluid max-height" alt="" />
        </ng-container>
        <ng-template #sin_logo>
          <img src="../../../../../../../assets/images/none-img.png" class="m-auto" alt="" />
        </ng-template>
        <span class="mt-2 mb-2"></span>
        <ng-container *ngIf="authService.getRolUser(adminSuper); else adminCC_2">
          <a class="btn btn-primary m-auto text-white" (click)="adjuntarLogo.click()"
            [style.opacity]="formCamara.valid ? 1:0.3">Adjuntar</a>
          <input #adjuntarLogo type="file" [hidden]="true" (change)="onFileInput($event, tipoContenido.logo)"
            [accept]="extensiones" [disabled]="!formCamara.valid" />
        </ng-container>
        <ng-template #adminCC_2>
          <a class="btn btn-primary m-auto text-white" (click)="adjuntarLogo.click()">Adjuntar</a>
          <input #adjuntarLogo type="file" [hidden]="true" (change)="onFileInput($event, tipoContenido.logo)"
            [accept]="extensiones" />
        </ng-template>
      </div>
    </section>
    <section class="col-6 pl-5 mb-5">
      <label class="text-dark h5 font-weight-bold mb-2">Firma</label>
      <p><strong>URL: </strong>{{dataFirma.ruta}}</p>
      <p><strong>Nombre archivo: </strong>{{dataFirma.nombre_archivo}}</p>
      <form [formGroup]="formFirma">
        <div class="form-group">
          <p>
            <strong>Nombre del funcionario:</strong>
          </p>
          <input id="nombre_firma" formControlName="nombre_firma" type="text" class="form-control form-control-sm">
        </div>
      </form>
      <div class="p-4 d-flex align-content-center flex-column">
        <ng-container *ngIf="firmaUrl; else sin_firma">
          <img [src]="firmaUrl | safeResourceUrl" class="m-auto img-fluid max-height" alt="" />
        </ng-container>
        <ng-template #sin_firma>
          <img src="../../../../../../../assets/images/none-img.png" class="m-auto" alt="" />
        </ng-template>
        <span class="mt-2 mb-2"></span>
        <ng-container *ngIf="authService.getRolUser(adminSuper); else adminCC">
          <a class="btn btn-primary m-auto text-white" (click)="adjuntarFirma.click()"
            [style.opacity]="formCamara.valid ? 1:0.3">Adjuntar</a>
          <input #adjuntarFirma type="file" [hidden]="true" (change)="onFileInput($event, tipoContenido.firma)"
            [accept]="extensiones" [disabled]="!formCamara.valid" />
        </ng-container>
        <ng-template #adminCC>
          <a class="btn btn-primary m-auto text-white" (click)="adjuntarFirma.click()">Adjuntar</a>
          <input #adjuntarFirma type="file" [hidden]="true" (change)="onFileInput($event, tipoContenido.firma)"
            [accept]="extensiones" />
        </ng-template>
      </div>
    </section>
    <footer class="text-right p-5 border-top w-100">
      <ng-container *ngIf="authService.getRolUser(adminSuper); else adminCC_button">
        <button type="button" class="btn btn-primary" (click)="enviarArchivo()" [disabled]="!formCamara.valid">Guardar
          cambios</button>
      </ng-container>
      <ng-template #adminCC_button>
        <button type="button" class="btn btn-primary" (click)="enviarArchivo()">Guardar
          cambios</button>
      </ng-template>
    </footer>
  </article>
</main>
